import { render, staticRenderFns } from "./problemInfo.vue?vue&type=template&id=68c91d0c"
import script from "./problemInfo.vue?vue&type=script&lang=js"
export * from "./problemInfo.vue?vue&type=script&lang=js"
import style0 from "./problemInfo.vue?vue&type=style&index=0&id=68c91d0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports